// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__1VC87","external":"Header_external__2Sv-O","hamburger":"Header_hamburger__uB-MN","logo":"Header_logo__3_SJs","internal":"Header_internal__3uFFP"};